import type { SVGProps } from 'react';

const SvgSearchLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M19.6464 20.3536C19.8417 20.5488 20.1583 20.5488 20.3536 20.3536C20.5488 20.1583 20.5488 19.8417 20.3536 19.6464L20 20L19.6464 20.3536ZM17 10.5H16.5C16.5 13.8137 13.8137 16.5 10.5 16.5V17V17.5C14.366 17.5 17.5 14.366 17.5 10.5H17ZM10.5 17V16.5C7.18629 16.5 4.5 13.8137 4.5 10.5H4H3.5C3.5 14.366 6.63401 17.5 10.5 17.5V17ZM4 10.5H4.5C4.5 7.18629 7.18629 4.5 10.5 4.5V4V3.5C6.63401 3.5 3.5 6.63401 3.5 10.5H4ZM10.5 4V4.5C13.8137 4.5 16.5 7.18629 16.5 10.5H17H17.5C17.5 6.63401 14.366 3.5 10.5 3.5V4ZM15 15L14.6464 15.3536L19.6464 20.3536L20 20L20.3536 19.6464L15.3536 14.6464L15 15Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgSearchLt;
